module.exports = __webpack_public_path__ + "static/img/course-detail.5625a91c.png";